"use client";

import React, { useState, useEffect, useMemo } from "react";
import { Line, LineChart, ResponsiveContainer } from "recharts";
import { Zap, Target, Globe, TrendingUp } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ChartContainer, type ChartConfig } from "@/components/ui/chart";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const metrics = [{
  id: 1,
  label: "Years ICT Experience",
  value: 30,
  suffix: "+",
  prefix: "",
  badge: "Precision",
  category: "experience"
}, {
  id: 2,
  label: "Years Project Delivery",
  value: 15,
  suffix: "+",
  prefix: "",
  badge: "Reliability",
  category: "delivery"
}, {
  id: 3,
  label: "Continents Delivered",
  value: 4,
  suffix: "",
  prefix: "",
  badge: "Expertise",
  category: "global"
}, {
  id: 4,
  label: "Project Budgets Managed",
  value: 10,
  suffix: "M+",
  prefix: "$",
  badge: "Performance",
  category: "scale"
}];
const chartConfig = {
  value: {
    label: "Growth",
    color: "hsl(174, 100%, 29%)"
  }
} satisfies ChartConfig;
function getIcon(category: string) {
  switch (category) {
    case "experience":
      return Zap;
    case "delivery":
      return Target;
    case "global":
      return Globe;
    case "scale":
      return TrendingUp;
    default:
      return Zap;
  }
}
function CountUp({
  end,
  duration = 2000,
  prefix = "",
  suffix = ""
}: {
  end: number;
  duration?: number;
  prefix?: string;
  suffix?: string;
}) {
  const [count, setCount] = useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const [hasAnimated, setHasAnimated] = useState(false);
  useEffect(() => {
    if (isVisible && !hasAnimated) {
      setHasAnimated(true);
      let startTime: number;
      let animationFrame: number;
      const animate = (timestamp: number) => {
        if (!startTime) startTime = timestamp;
        const progress = timestamp - startTime;
        const percentage = Math.min(progress / duration, 1);
        const ease = 1 - Math.pow(1 - percentage, 4);
        setCount(Math.floor(end * ease));
        if (progress < duration) {
          animationFrame = requestAnimationFrame(animate);
        } else {
          setCount(end);
        }
      };
      animationFrame = requestAnimationFrame(animate);
      return () => cancelAnimationFrame(animationFrame);
    }
  }, [isVisible, hasAnimated, end, duration]);
  return <span ref={ref as React.RefObject<HTMLSpanElement>}>
      {prefix}{count}{suffix}
    </span>;
}
export default function ImpactMetrics() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll();
  const sparklineData = useMemo(() => {
    return metrics.map((_, idx) => Array.from({
      length: 12
    }, (__, i) => ({
      time: i,
      value: 30 + Math.sin((i + idx) * 0.8) * 15 + Math.random() * 5
    })));
  }, []);
  return;
}